export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14037.5db9d1cf.jpg";